import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../main/components/Modal';
import CheckboxAndLabel from '../../util/form/components/CheckboxAndLabel';
import { selectAllAniamls, selectAnimals } from '../actions';
import {
  countSelectedAnimals,
  filteredAnimalsAllSelected,
  getFilteredAnimals
} from '../reducer';
import './animal-selection-action-header.scss';
import AnimalCuttingForm from './AnimalCuttingForm';
import AnimalSlaughterForm from './AnimalSlaughterForm';

const AnimalSelectionActionHeader = () => {
  const [ showKillModal, setShowKillModal ] = useState(false);
  const [ showCuttingModal, setShowCuttingModal ] = useState(false);
  const selectedCount = useSelector(countSelectedAnimals);
  const allSelected = useSelector(filteredAnimalsAllSelected);
  const filteredAnimals = useSelector(getFilteredAnimals);
  const dispatch = useDispatch();
  const className = selectedCount ? 'animal-selection-action-header visible' :
    'animal-selection-action-header';
  const selectText = allSelected ?
    'deselect all' : 'select all';
  const toggleAll = () => {
    if (allSelected) {
      dispatch(selectAllAniamls(false));
    } else {
      dispatch(selectAnimals(filteredAnimals, true));
    }
  };
  const closeKillModal = () => {
    setShowKillModal(false);
    dispatch(selectAllAniamls(false));
  };
  const toggle = (
    <CheckboxAndLabel label={ selectText }
      isChecked={ allSelected }
      toggle={ toggleAll } />
  );
  const killModal = showKillModal ? (
    <Modal pos={ window.scrollY } close={ () => setShowKillModal(false) } >
      <AnimalSlaughterForm close={ closeKillModal }
        count={ selectedCount} />
    </Modal>
  ) : null;
  const cuttingModal = showCuttingModal ? (
    <Modal pos={ window.scrollY } close={ () => setShowCuttingModal(false) } >
      <AnimalCuttingForm close={ closeKillModal }
        count={ selectedCount} />
    </Modal>
  ) : null;
  const selection = selectedCount < 2 ? `${selectedCount} animal selected` :
    `${selectedCount} animals selected`;
  return (
    <div data-cy="animal-selection-action-header" className={ className }>
      <div className="count">
        { selection }
      </div>
      <div className="actions">
        <div className="button"
          data-cy="record-slaughter-button"
          onClick={ () => setShowKillModal(true) }>
          Record Slaughter
        </div>
        <div className="button"
          data-cy="record-cutting-button"
          onClick={ () => setShowCuttingModal(true) }>
          Record Cutting
        </div>
      </div>
      { toggle }
      { killModal }
      { cuttingModal }
    </div>
  );
};

export default AnimalSelectionActionHeader;
